import type { AccessRole } from "~/utils/effectiveAccess";

// The server spells a super's role id from its rung label; nothing else ends
// this way.
const SUPER_USER_SUFFIX = "-SuperUser";

export const isSuperRole = (role: AccessRole | undefined): boolean =>
  role?.capability === "super";

export const isSuperAdminRole = (role: AccessRole | undefined): boolean =>
  isSuperRole(role) && !role?.id.endsWith(SUPER_USER_SUFFIX);

export const isAdminOrSuperRole = (role: AccessRole | undefined): boolean =>
  role?.capability === "admin" || isSuperRole(role);
